import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
    const { pathname, hash } = useLocation();
    const location = useLocation();

    useEffect(() => {
        if (!location.pathname.replace("/", "").includes("delete")) {
            window.scrollTo(0, 0);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pathname]);

    useEffect(() => {
        if (!hash) return;

        const timer = setTimeout(() => {
            const element = document.getElementById(hash.substring(1));
            element?.scrollIntoView({
                behavior: "smooth",
                block: "start",
            });
        }, 50);

        return () => clearTimeout(timer);
    }, [hash]);

    return null;
}